export default "__VITE_ASSET__2AmbZAdb__"